/**
 * Timeline Block Configuration
 *
 * Registry config for the project timeline/phases block type.
 */

import { Clock } from "lucide-react";
import { TimelineBlock } from "@/canvas/components/blocks/TimelineBlock";
import type { BlockConfig } from "../types";

export const timelineBlockConfig: BlockConfig<"timeline"> = {
  type: "timeline",
  component: TimelineBlock,
  icon: Clock,
  iconClassName: "text-blue-500",
  label: "canvas.blockTypes.timeline",
  defaultContent: () => ({ phases: [] }),
  showInAddBlockMenu: true,
};
